import { useHeaderHeight } from '@e3dc-react/shell/Libs/Header'
import { Box, useScrollTrigger, useTheme } from '@mui/material'
import { SxProps, useMediaQuery } from '@mui/system'
import React from 'react'

interface ScrollObserverContainerProps {
  children: React.ReactNode
  sxStyle?: SxProps
  isSticky?: boolean
}

const PADDING_TOP = 12

/**
 * Container to make children sticky to the top of the screen when scrolling
 */
const StickyContainer: React.FC<ScrollObserverContainerProps> = ({ children, isSticky, sxStyle }) => {
  const theme = useTheme()
  const { height: appHeaderHeight } = useHeaderHeight()
  const isScrollTriggered = useScrollTrigger()
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'))
  const top = calculateTopMargin(appHeaderHeight, isScrollTriggered, isUpMd)

  return (
    <Box
      sx={{
        position: 'sticky',
        zIndex: theme.zIndex.appBar,
        alignSelf: 'center',
        width: '100%',
        transition: theme.transitions.create('all'),
        top: isSticky ? `${top}px` : 0,
        ...sxStyle,

        [theme.breakpoints.up('sm')]: {
          top: `${top}px`,
        },
      }}
    >
      {children}
    </Box>
  )
}

export default StickyContainer

const calculateTopMargin = (appHeaderHeight: number, isScrollTriggered: boolean, isUpMd: boolean): number => {
  if (isUpMd) return appHeaderHeight + PADDING_TOP

  if (isScrollTriggered) return 0

  return appHeaderHeight
}
